<template>
  <div>
    <label
      v-if="titulo != 'hide'"
      v-bind:class="{
        'text-danger': current.errors && current.errors.tienda,
      }"
      >{{ titulo }}</label
    >
    <select
      v-bind:class="sin_borde ? _class+' sin_borde' : _class"
      style="width: 100%"
      autofocus="autofocus"
      required
      v-model="current.tienda"
      :disabled="isdisabled || disabled"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    >
      <option v-if="incluir_en_blanco" value="null">Elije una tienda</option>
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option
        v-for="(tienda, key) in tiendas"
        :value="tienda.codigo"
        :key="key"        
      >
        {{ tienda.codigo }} - {{ tienda.nombre }}
      </option>
    </select>
    <small
      v-if="current.errors && current.errors.tienda"
      class="form-text text-danger"
      >{{ current.errors.tienda[0] }}</small
    >
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    desblock: {
      type: Boolean,
      required: false,
    },
    titulo: {
      type: String,
      default: "Tienda",
    },
    _class: {
      type: String,
      default: "form-control",
    },
    incluir_en_blanco: {
      type: Boolean,
      default: false,
    },
    myprofile: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    }, 
    /*
    sin_borde en estado true desde componente padre 
    elimina bordes, margin y padding, para poder insertarlo
    a una tabla y que tome el tamaño de la celda
     */
    sin_borde: {
      type:Boolean,
      default:false
    },
    etiqueta:{
        type: String,
        default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    isdisabled: function () {
      let self = this;
      if (self.desblock == true) {
        return false;
      }
      if (self.current.estado != undefined) {
        return self.current.estado != "A";
      }
      return false;
    },
  },
  mounted() {   
    if (this.myprofile === false) {
      this.initialize_component();
    } else {
      this.is_myProfile_initialize_component();
    }    
  },
  methods: {
    /**
     * Funcion que nos sirve para iniciar la data del select
     * con todas las tiendas en estado Activo.
     */
    initialize_component() {
    //   this.$store.dispatch("catalogos/llenar_tiendas", {
    //     activa: true,
    //     quitar_paginacion: true,
    //   });
      this.getTiendasPorEtiqueta(this.etiqueta);
      let self = this;
      if (self.current.estado == undefined) {
        self.current.estado = "A";
      }
    },

    /**
     * Funcion que nos sirve para iniciar la data del select
     * con las tiendas que estan asociadas al usuario de la sesión.
     */
    is_myProfile_initialize_component() {
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
      })
        .then((response) => {
          let tiendas = [];
          let tiendasData = response.data.results;
          tiendasData.forEach(element => {
            tiendas.push(element.tienda);
          });
          this.setTiendas(tiendas);
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          Notifications.alert.error(
            "No se pudieron obtener las tiendas.",
            error.response.data.detail
          );
        });
    },

    /**
     * Función que actualiza el estado del store de Tiendas en select,
     * si la prop myprofile es 'true'
     */
    setTiendas(tiendas) {
      try {
        this.$store.commit('catalogos/TIENDAS', tiendas);
      } catch (error) {
        console.error('Error committing to store:', error);
      }
    },
    getTiendasPorEtiqueta(etiqueta) {
        let tiendas = [];
        DynamicService.fetch("cat", "etiquetas-tiendas", {
            etiqueta: etiqueta,
            activa: true,
            quitar_paginacion: true,
        })
        .then((response) => {
            let tiendasData = response.data;
            tiendasData.forEach(element => {
                tiendas.push(element.tienda_obj);
            });
            this.setTiendas(tiendas);
        })
    }
  },
};
</script>

<style>
.sin_borde{
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  height: 100% !important;
  box-shadow: none !important;
}
</style>
